var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 20.75V18.5833C18.6668 17.4341 18.2103 16.3319 17.3976 15.5192C16.585 14.7065 15.4828 14.25 14.3335 14.25H5.66683C4.51756 14.25 3.41536 14.7065 2.6027 15.5192C1.79004 16.3319 1.3335 17.4341 1.3335 18.5833V20.75M14.3335 5.58333C14.3335 7.97657 12.3934 9.91667 10.0002 9.91667C7.60693 9.91667 5.66683 7.97657 5.66683 5.58333C5.66683 3.1901 7.60693 1.25 10.0002 1.25C12.3934 1.25 14.3335 3.1901 14.3335 5.58333Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c8a2bc3322d4924b4b157be6325bfe8a.svg";
export { ForwardRef as ReactComponent };